import { useButton, Ripple, Spinner } from "@heroui/react";
import { forwardRef } from "react";
import type { CSSProperties } from "react";
import type { IButtonProps } from "../config";


const Btn = forwardRef<HTMLButtonElement, IButtonProps>((props, ref) => {
  const typeBtn = {
    base: "btn btn--isCustomLinearBg w-45 mobile:w-full tablet:h-13 mobile:h-13 mobile:text-3xl h-16 px-6 rounded-[9999px] font-semibold text-4xl text-cherrywood transition-all ",
    secondary: "btn rounded-[9999px] font-semibold text-4xl bg-white mobile:w-full text-cherrywood shadow-sm transition-all hover:shadow-md h-16 mobile:h-13 px-10 py-5",
    ghost: "btn btn--isBorderLinearBg h-12 px-6 rounded-[9999px] font-semibold text-cherrywood transition-all box-content",
  };

  const {
    domRef,
    children,
    spinnerSize,
    spinner = <Spinner color={"current"} size={spinnerSize} />,
    spinnerPlacement,
    startContent,
    endContent,
    isLoading,
    disableRipple,
    getButtonProps,
    getRippleProps,
  } = useButton({
    ref,
    ...props,
    className: typeBtn[props.typeStyle ?? "base"] + (props.className ?? ""),
  });

  const { ripples, onClear } = getRippleProps();

  if (props.href || props.as === "a") {
    return (
      <a
        href={props.href}
        ref={domRef} {...getButtonProps()} 
        style={{ "--deepsum-hover-opacity": "1" } as CSSProperties}
        type={undefined}
      >
        {children}
      </a>
    );
  }

  return (
    <button ref={domRef} {...getButtonProps()} style={{ "--deepsum-hover-opacity": "1" } as CSSProperties}>
      {startContent}
      {isLoading && spinnerPlacement === "start" && spinner}
      {children}
      {isLoading && spinnerPlacement === "end" && spinner}
      {endContent}
      {!disableRipple && <Ripple ripples={ripples} onClear={onClear} />}
    </button>
  );
});

Btn.displayName = "Btn";

export default Btn;
